import React, { useCallback, useEffect, useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { MdArrowBack } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import ProductForm from '../../components/Products/ProductForm';
import { applyFormChange, authToken, buildProductFormData, FONT, initialFormState } from '../../components/Products/productShared';
import { getData, postFileUpload } from '../../Webservice/Webservice';
import PRODUCT_ROUTES from '../../API_Route/ProductRoute';

const AddProduct = () => {
    const navigate = useNavigate();
    const [form, setForm] = useState(initialFormState);
    const [categories, setCategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [submitting, setSubmitting] = useState(false);
    const [serverError, setServerError] = useState('');

    const fetchCategories = useCallback(async () => {
        try {
            const res = await getData('categories/list?limit=1000', null, authToken(), false);
            setCategories(Array.isArray(res?.categories) ? res.categories : []);
        } catch { setCategories([]); }
    }, []);

    const fetchSubcategories = useCallback(async (categoryId) => {
        if (!categoryId) { setSubcategories([]); return; }
        try {
            const res = await getData(`subcategories/list?limit=1000&category_id=${categoryId}`, null, authToken(), false);
            setSubcategories(Array.isArray(res?.subcategories) ? res.subcategories : []);
        } catch { setSubcategories([]); }
    }, []);

    useEffect(() => { fetchCategories(); }, [fetchCategories]);
    useEffect(() => { fetchSubcategories(form.category_id); }, [form.category_id, fetchSubcategories]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((f) => applyFormChange(f, name, value));
    };

    const handleAddProduct = async () => {
        setSubmitting(true);
        setServerError('');
        try {
            await postFileUpload(PRODUCT_ROUTES.ADD_PRODUCT, buildProductFormData(form), authToken(), false);
            navigate('/productmanagement', { state: { notice: `“${form.title.trim()}” was added.` } });
        } catch (error) {
            setServerError(error?.message || 'Could not add the product.');
            window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Box sx={{ p: { xs: 1.5, md: 3 }, fontFamily: FONT }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2.5 }}>
                <IconButton onClick={() => navigate('/productmanagement')} sx={{ background: '#f1f5f9' }}><MdArrowBack size={18} /></IconButton>
                <Box>
                    <Typography sx={{ fontFamily: FONT, fontWeight: 800, fontSize: 24, color: '#0f172a' }}>Add product</Typography>
                    <Typography sx={{ fontFamily: FONT, fontSize: 13.5, color: '#64748b' }}>Fill in each section, then create. Stock is added later through receiving.</Typography>
                </Box>
            </Box>
            <ProductForm
                form={form}
                onFormChange={handleChange}
                onCancel={() => navigate('/productmanagement')}
                onSubmit={handleAddProduct}
                categories={categories}
                subcategories={subcategories}
                isEdit={false}
                fetchCategories={fetchCategories}
                fetchSubcategories={fetchSubcategories}
                submitting={submitting}
                serverError={serverError}
            />
        </Box>
    );
};

export default AddProduct;
